import { render } from "./practice-parent-child-template.vue?vue&type=template&id=e5bbb998"
import script from "./practice-parent-child-template.vue?vue&type=script&lang=js"
export * from "./practice-parent-child-template.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__